import React from "react";

const SalesHistoryIcon = () => {
  return (
<svg width="14" height="13" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.7089 12.9497C5.88686 14.095 7.43685 14.8077 9.09473 14.9663C10.7526 15.125 12.4158 14.7198 13.8008 13.8199C15.1859 12.9199 16.2071 11.5809 16.6904 10.0309C17.1737 8.48098 17.0893 6.81604 16.4514 5.31984C15.8136 3.82364 14.6618 2.58877 13.1924 1.82567C11.723 1.06257 10.0269 0.81847 8.39315 1.13496C6.75937 1.45145 5.28903 2.30894 4.23268 3.56132C3.17634 4.81369 2.59937 6.38344 2.6001 8.00306V9.55551" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 7.99978L2.6 9.55534L4.2 7.99978M9 4.88867V8.77756H13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
};

export default SalesHistoryIcon;